import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { useAtom } from 'jotai';
import { isEmpty, isObject, sortBy, startCase } from 'lodash';
import ReactMarkdown from 'react-markdown';

import LargeCard from '@/components/LargeCard';
import MarkdownLink from '@/components/MarkdownLink/MarkdownLink';
import {
  escapeStrikethrough,
  MARKDOWN_REMARK_PLUGINS
} from '@/constants/markdown.constants';
import { CaseIdLink } from '@/pages/Case/CaseIdLink';
import { ticketAtom } from '@/pages/Ticket';
import { hasMarkdownSyntax } from '@/utils/Common.utils';

const TicketDetailsAdditionalDetails = () => {
  const [{ additional_details }] = useAtom(ticketAtom);

  if (isEmpty(additional_details)) {
    return null;
  }

  const entries = sortBy(Object.entries(additional_details), [0]);

  const getCellContent = (value: unknown) => {
    switch (true) {
      case typeof value === 'string' && value.includes('<'):
        // biome-ignore lint/security/noDangerouslySetInnerHtml: additional details may contain HTML markup; not sanitized client-side, content comes from the backend
        return <div dangerouslySetInnerHTML={{ __html: value }} />;
      case typeof value === 'string' && hasMarkdownSyntax(value):
        return (
          <ReactMarkdown
            components={{
              a: MarkdownLink
            }}
            remarkPlugins={MARKDOWN_REMARK_PLUGINS}
          >
            {escapeStrikethrough(value)}
          </ReactMarkdown>
        );
      case typeof value === 'string':
        return <CaseIdLink>{value}</CaseIdLink>;
      case isObject(value):
        return (
          <pre style={{ margin: 0 }}>{JSON.stringify(value, null, 2)}</pre>
        );
      default:
        return JSON.stringify(value, null, 2);
    }
  };

  return (
    <LargeCard title="Additional Details">
      <Table size="small">
        <TableBody>
          {entries.map(([key, value]) => (
            <TableRow key={key}>
              <TableCell width={200}>{startCase(key)}</TableCell>
              <TableCell>{getCellContent(value)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </LargeCard>
  );
};

export default TicketDetailsAdditionalDetails;
